/*
 * @Date: 2024-05-10 09:54:38
 * @LastEditTime: 2025-02-07 14:52:08
 * @Description: utils
 * @FilePath: /ql-official/src/utils/index.ts
 */

export function throttle<T extends (...args: unknown[]) => unknown>(
  func: T,
  wait: number,
  options?: {
    leading?: boolean;
    trailing?: boolean;
  }
): (...args: Parameters<T>) => ReturnType<T> {
  let context: unknown;
  let args: Parameters<T> | null;
  let result: ReturnType<T> | unknown;
  let timeout: number | null = null;
  let previous = 0;
  if (!options) options = options || {};
  const later = function () {
    previous = options?.leading === false ? 0 : new Date().getTime();
    timeout = null;
    if (args) result = func.apply(context, args);
    if (!timeout) context = args = null;
  };
  return function (this: unknown, ..._args: Parameters<T>) {
    const now = new Date().getTime();
    if (!previous && options?.leading === false) previous = now;
    const remaining = wait - (now - previous);
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    context = this;
    args = _args;
    if (remaining <= 0 || remaining > wait) {
      if (timeout) {
        clearTimeout(timeout);
        timeout = null;
      }
      previous = now;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    } else if (!timeout && options?.trailing !== false) {
      timeout = window.setTimeout(later, remaining);
    }
    return result as ReturnType<T>;
  };
}

export function startsWithHttp(url: string) {
  return url.startsWith("http://") || url.startsWith("https://");
}

// 处理 url
export function handlingUrl(url?: string | null | undefined) {
  if (url?.startsWith("/uploads/images")) {
    return process.env.VUE_APP_API_URL + url;
  }

  return url;
}

export function openUrl(url?: string) {
  if (!url) return;

  if (startsWithHttp(url)) {
    window.open(url, "_blank");
    return;
  }

  window.open(`https://${url}`, "_blank");
}

export function splitTitle(title?: string | null | undefined) {
  if (!title) {
    return "";
  }

  // </br> or <br/>
  return title.split(/<\/?br\s*\/?>/gi)[0];
}

export function htmlDecode(value?: string | null | undefined): string {
  const result = (value || "")
    .replace(/&amp;/g, "&")
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")
    .replace(/&lt;/g, "<")
    .replace(/&gt;/g, ">");
  return /&amp;/gi.test(result) ? htmlDecode(result) : result;
}
